import { CapoPlugin } from "/Users/laurentlang/Documents/Websites/Online/Patchbox/pb-rack-planner-v3/frontend/node_modules/@unhead/vue/dist/index.mjs";
export default import.meta.server ? [CapoPlugin({ track: true })] : [];